module.exports = __webpack_public_path__ + "images/fa-cfa-instructor-antoniya-baltova.webp";